export enum DiscountType {
  PERCENT = "PERCENT",
  FIXED = "FIXED",
}
